import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyProjectEditProjectState } from './projectEdit.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerProjectEdit = (
  state: AppState,
  projectId: number | null,
) => {
  if (projectId == null) return createEmptyProjectEditProjectState()
  return (
    state.taskTracker.projectEdit.byProjectId[projectId] ??
    createEmptyProjectEditProjectState()
  )
}
